import React from 'react';

interface IPropsRelativeCenter {
    children?: React.ReactNode;
}

export const RelativeCenter: React.FC<IPropsRelativeCenter> = ({ children }) => {
    return <div className="relative-center">{children}</div>;
};
